






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminDepositShowTabular from '@/modules/deposit/components/admin/AdminDepositShowTabular.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import AdminDepositCreateForm from '@/modules/deposit/components/admin/AdminDepositCreateForm.vue'
import AdminTicketShowTabular from '@/modules/ticket/components/admin/AdminTicketShowTabular.vue'
import AdminTicketSetting from '@/modules/ticket/components/admin/AdminTicketSetting.vue'
import AdminTicketNewAnswerForm from '@/modules/ticket-answer/components/admin/AdminTicketNewAnswerForm.vue'
import TicketAnswerList from '@/modules/ticket-answer/components/shared/TicketAnswerList.vue'
import { VipGroupResourceModel, VipGroupResourceType } from '@/modules/vip-group/models/vip-group-resource.model'
import AdminVipGroupCreateForm from '@/modules/vip-group/components/admin/AdminVipGroupCreateForm.vue'
import { VipGroupUpdateUseCase } from '@/modules/vip-group/use-cases/admin/vip-group-update.use-case'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'گروه ویژه'
  },
  metaInfo: {
    title: 'گروه ویژه'
  },
  components: {
    AdminVipGroupCreateForm,
    AdminTicketAnswerList: TicketAnswerList,
    AdminTicketSetting,
    AdminTicketNewAnswerForm,
    AdminTicketShowTabular,
    AdminDepositCreateForm,
    CopyableText,
    TesDatePicker,
    BaseSelect,
    CurrencyInput,
    AdminDepositShowTabular,
    SimpleHeader,
    AdminUserInfoButton,
    BaseCard,
    BaseInput,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class ShowPage extends Vue {
  constructor(
    private readonly vipGroupUpdateUseCase: VipGroupUpdateUseCase
  ) {
    super()
  }

  @Prop() vipGroup!: VipGroupResourceType
  private group: VipGroupResourceModel = this.initData()
  private isLoading: boolean = false

  onSubmit(data) {
    this.isLoading = true
    this.vipGroupUpdateUseCase.execute(this.vipGroup.data.id, data).then(() => {
      this.isLoading = false
    })
  }

  initData(): VipGroupResourceModel {
    return {
      active: this.vipGroup.data.active,
      created_at: this.vipGroup.data.created_at,
      description: this.vipGroup.data.description,
      id: this.vipGroup.data.id,
      percent: this.vipGroup.data.percent,
      title: this.vipGroup.data.title,
      updated_at: this.vipGroup.data.updated_at,
      users: this.getUsersIdList()
    }
  }

  getUsersIdList(): Array<number> {
    const usersIdList = []
    this.vipGroup.data.users.forEach(item => {
      //@ts-ignore
      usersIdList.push(item.id || item)
    })
    return usersIdList
  }

}
